<template>
    <div>
        <div>
            <div>
                <el-row>
                    <div class="left-justifying"><h3>{{pageTitle}}</h3></div>
                    <div class="right-justifying">
                        <el-button type="info" plain size="small" @click="saveAdd" v-if="saveAddBtnExisted">
                            <i class="fa fa-save"></i> 保存
                        </el-button>
                        <el-button type="info" plain size="small" @click="saveEdit" v-if="saveEditBtnExisted">
                            <i class="fa fa-save"></i> 保存
                        </el-button>
                        <el-button type="info" plain size="small" @click="cancelEdit" v-if="cancelEditBtnExisted">
                            <i class="fa fa-undo"></i> 取消
                        </el-button>
                    </div>
                </el-row>
            </div>
            <div class="panel">
                <div class="panel-body">
                    <el-row>
                        <div class="advanced-search-location" v-show="activeTabName === 'list'">
                            <el-date-picker v-model="list.search.year" value-format="yyyy" type="year" size="small" placeholder="年份">
                            </el-date-picker>
                        </div>
                        <el-tabs v-model="activeTabName" :before-leave="beforeLeave">
                            <el-tab-pane label="列表" name="list">
                                <contract-item-record-list ref="list" :search="list.search"></contract-item-record-list>
                            </el-tab-pane>
                            <el-tab-pane label="详情" name="detail">
                                <contract-item-record-detail ref="detail" :data="detail.data"></contract-item-record-detail>
                            </el-tab-pane>
                        </el-tabs>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        COMPONENT_MAIN,
        FN_LIST_QUERY, FN_SET_OPERATION, FN_SET_TAB, FN_TO_DETAIL_SHOW, FN_TO_DETAIL_ADD, FN_TO_DETAIL_EDIT,
        OPERATION_DETAIL_ADD, OPERATION_DETAIL_EDIT, OPERATION_LIST_DEFAULT, OPERATION_DETAIL_SHOW,
        TAB_LIST, TAB_DETAIL,
        PERMISSION_ADD, PERMISSION_DELETE, PERMISSION_EDIT,
        ENUM_CONTENT_POWER,
        contentHash,
        getContentByQuery,
    } from './contract.item.record.common'
    import ContractItemRecordList from './contract.item.record.list'
    import ContractItemRecordDetail from './contract.item.record.detail'

    export default {
        name: COMPONENT_MAIN,
        componentName: COMPONENT_MAIN,
        components: {ContractItemRecordList, ContractItemRecordDetail},
        data() {
            return {
                activeTabName: TAB_LIST,
                operation: null,
                list: {
                    search: {
                        year: new Date().getFullYear() + '',
                    }
                },
                detail: {
                    data: null,
                }
            };
        },
        computed: {
            pageTitle() {
                let content = getContentByQuery(this.$route.query);
                return contentHash[content];
            },
            saveAddBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_ADD &&
                    (PERMISSION_ADD == null || this.hasPermission(PERMISSION_ADD));
            },

            saveEditBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_EDIT &&
                    (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
            cancelEditBtnExisted() {
                return this.activeTabName === TAB_DETAIL && this.operation === OPERATION_DETAIL_EDIT &&
                    (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
        },
        methods: {
            setDefaultOperation(tabName) {
                if (this.operation == null || this.operation.split('.')[0] !== tabName) {
                    let operation;
                    if (tabName === TAB_LIST) {
                        operation = OPERATION_LIST_DEFAULT;
                        this[FN_LIST_QUERY]();
                    } else if (tabName === TAB_DETAIL) {
                        operation = OPERATION_DETAIL_SHOW;
                        this.detail.data = this.$refs['list'].currentRowData;
                    }
                    if (operation != null) {
                        this[FN_SET_OPERATION](operation);
                    }
                }
            },
            beforeLeave(tabName, oldTabName) {
                if (this.$refs['detail'] != null && this.$refs['detail'].formIsDirty != null && this.$refs['detail'].formIsDirty()) {
                    return this.$confirm('您输入的数据未保存，确认离开吗？', '离开提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$refs['detail'].resetForm();
                        this.setDefaultOperation(tabName);
                        return Promise.resolve();
                    }, () => {
                        return Promise.reject();
                    });
                } else {
                    this.setDefaultOperation(tabName);
                }
                return Promise.resolve();
            },
            [FN_SET_TAB](tabName) {
                this.activeTabName = tabName;
            },
            [FN_SET_OPERATION](operation) {
                this.operation = operation;
            },
            [FN_TO_DETAIL_SHOW](data) {
                this[FN_SET_TAB](TAB_DETAIL);
                this[FN_SET_OPERATION](OPERATION_DETAIL_SHOW);
                this.detail.data = data;
            },
            [FN_TO_DETAIL_ADD](data) {
                this[FN_TO_DETAIL_SHOW](data);
                this.$nextTick(() => {
                    this.toAdd();
                });
            },
            [FN_TO_DETAIL_EDIT](data) {
                this[FN_TO_DETAIL_SHOW](data);
                this.$nextTick(() => {
                    this.toEdit();
                });
            },
            [FN_LIST_QUERY]() {
                this.$refs['list'].query();
            },
            toAdd() {
                this[FN_SET_TAB](TAB_DETAIL);
                this[FN_SET_OPERATION](OPERATION_DETAIL_ADD);
                this.$refs['detail'].toAdd();
            },
            saveAdd() {
                this.$refs['detail'].saveAdd();
            },
            toEdit() {
                this[FN_SET_TAB](TAB_DETAIL);
                this[FN_SET_OPERATION](OPERATION_DETAIL_EDIT);
            },
            saveEdit() {
                this.$refs['detail'].saveEdit();
            },
            cancelEdit() {
                this.$refs['detail'].cancelEdit();
            },
            toRemove() {
                this.$refs['detail'].toRemove();
            }
        },
        created() {
            [FN_SET_TAB, FN_SET_OPERATION, FN_TO_DETAIL_SHOW, FN_TO_DETAIL_EDIT, FN_TO_DETAIL_ADD].forEach(fnName => {
                this.$on(fnName, (data) => {
                    this[fnName](data);
                });
            });
        },
        mounted() {
            this.$nextTick(() => {
                this[FN_LIST_QUERY]();
            });
        }
    }
</script>

<style scoped>

</style>
